import store from '@/states/index.js'

import FileManager from '../FileManager.vue'

export default [
    {
        path: '/filemanager',
        component: FileManager,
        name: 'filemanager',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]